
import { memo } from "react"
const HighLowCandles = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.42857 6H6V18H10.2857V6H6.42857ZM6.85714 17.1429V6.85714H9.42857V17.1429H6.85714ZM13.2857 7.71429H12.8571V16.2857H17.1429V7.71429H13.2857ZM13.7143 15.4286V8.57143H16.2857V15.4286H13.7143Z" fill="currentColor"/>
        </svg>
    )
}

export default memo(HighLowCandles)